import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import AppRouter from './components/router';
import './styles/tailwind.css';

import store from './store';

const API_URL = window.location.host.includes('localhost') ? 'http://localhost:3001' : 'https://enigmatic-shelf-39065.herokuapp.com';
setInterval(() => {
    if (window.location.pathname !== '/') {
        fetch(`${API_URL}/api/hb`, {
            headers: new Headers({'Authorization': `Bearer ${localStorage.getItem('id_token')}`}),
        })
            .then(resp => resp.json())
            .then(json => {
                if (json.statusCode >= 400 && json.statusCode < 500) {
                    return window.location = '/logout';
                }
            })
            .catch(err => console.log(err));
    }
}, 45000);

ReactDOM.render(
    <Provider store={store}>
        <AppRouter />
    </Provider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js